import { Injectable } from '@angular/core';
import * as Crypto from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  public encrypt(data: any, secretKey: string): string {
    return Crypto.AES.encrypt(data, secretKey).toString();
  }

  public decrypt(encrypted: any, secretKey: string): any {
    return Crypto.AES.decrypt(encrypted, secretKey).toString(Crypto.enc.Utf8);
  }
}
